module.exports = __webpack_public_path__ + "assets/media/Animation Flythrough.91ab2a49.mp4";